export default __webpack_public_path__ + "static/media/geo-6.a0d66599.png";